module.exports = __webpack_public_path__ + "static/TruenoUltBlk-9b815b550c4941f52d53313e0f27af73.woff";